import React from 'react';
export function BonusSection() {
  const bonuses = [{
    title: 'Resin Cost Calculator',
    desc: 'Never underprice your work again',
    image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?q=80&w=1000&auto=format&fit=crop'
  }, {
    title: 'Etsy Starter Guide',
    desc: 'Setup your shop in one afternoon',
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f7a07d?q=80&w=1000&auto=format&fit=crop'
  }, {
    title: 'Advanced Finishing',
    desc: 'Get that glass-like mirror shine',
    image: 'https://images.unsplash.com/photo-1516975080664-ed2fc6a32937?q=80&w=1000&auto=format&fit=crop'
  }, {
    title: 'Extra Guided Project',
    desc: 'Create a botanical tray together',
    image: 'https://images.unsplash.com/photo-1615655406736-b37c4fabf923?q=80&w=1000&auto=format&fit=crop'
  }];
  return <section className="py-20 bg-stone-900 text-white" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="text-center mb-16" data-id="element-3">
          <span className="text-teal-400 font-bold tracking-wider uppercase text-sm mb-2 block" data-id="element-4">
            Limited Time Offer
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-5">
            Exclusive Bonuses Included
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-6">
          {bonuses.map((bonus, idx) => <div key={idx} className="bg-stone-800 rounded-xl overflow-hidden border border-stone-700 group hover:border-teal-500/50 transition-colors" data-id="element-7">
              <div className="h-40 bg-stone-700 relative overflow-hidden" data-id="element-8">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover opacity-60 group-hover:opacity-80 transition-opacity" data-id="element-9" />
                <div className="absolute top-2 right-2 bg-teal-600 text-white text-xs font-bold px-2 py-1 rounded" data-id="element-10">
                  Included Today
                </div>
              </div>
              <div className="p-5" data-id="element-11">
                <h3 className="text-lg font-bold text-white mb-1" data-id="element-12">
                  {bonus.title}
                </h3>
                <p className="text-stone-400 text-sm" data-id="element-13">{bonus.desc}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}